import { render } from "./UserPermissions.vue?vue&type=template&id=05f8ffc5"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"

import "./UserPermissions.vue?vue&type=style&index=0&id=05f8ffc5&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__